<template>
  <div class="flex align-center gap-2">
    <!-- <VaButton @click="setDateRange()"> Apply</VaButton> -->
    <VaSelect v-model="dateFormat" class="w-1/2" :options="options" placeholder="Select an option" />
    <VaButton preset="primary" class="mb-2 font-normal">
      <RouterLink to="account/alerts">
        {{ domainsAlertObjList.includes(dashBoardStore.domain) ? 'Edit alert' : 'Set alert' }}</RouterLink
      >
    </VaButton>
  </div>

  <div class="override">
    <!-- <VaModal ok-text="Apply" style="z-index: 0" blur :fullscreen="true"> </VaModal> -->
    <VaModal v-model="calendarModal" blur no-padding z-index="0" size="small">
      <template #content="{}">
        <VaCardContent class="h-80 w-32">
          <div class="flex gap-4">
            <div class="">
              <VaSelect
                v-model="dateFormat"
                class="bg-white"
                is-open="true"
                :options="options"
                placeholder="Select an option"
              />
            </div>
            <div class="">
              <VaDateInput
                v-model="range"
                class="bg-white"
                style="z-index: 1000"
                :readonly="false"
                :is-open="true"
                :format-date="formatDate"
                :rules="validationRules"
                :parse-date="parseDate"
                :allowed-days="allowedDays"
                :allowed-years="allowedYears"
                :allowed-months="allowedMonths"
              />
            </div>
          </div>
        </VaCardContent>
        <VaCardActions><VaButton @click="setDateRange()"> Apply</VaButton></VaCardActions>
      </template>
    </VaModal>
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import { useDomainStore } from '@/stores/dashBoardStore'
import { RouterLink } from 'vue-router'
import { sortByDate } from '../../../data/arrayUtil'
import { useAlertStore } from '../../../stores/alertStore'
import { useAuthStore } from '../../../stores/authStore'
import { postDataAuth } from '../../../data/api/fetchData'

const authStore = useAuthStore()
const alertStore = useAlertStore()
const domainsAlertObjList = ref(addDomains(alertStore.alertDataObj))
console.log('domainsAlertObjList : ', domainsAlertObjList.value)
const dashBoardStore = useDomainStore()
const range = ref({ start: dashBoardStore.startDate, end: dashBoardStore.endDate })
const options = ref(['Last 7 days', 'Last 10 days', 'Last 15 days', 'Last 30 days', 'Last 90 days', 'Custom range'])
const dateFormat = ref(options.value[3])
const calendarModal = ref(false)
const displayStartDate = ref('')
const displayEndDate = ref('')

const formatDate = (date) => {
  return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
}

const parseDate = (text) => {
  const [day, month, year] = text.split('/')
  return new Date(parseInt(year), parseInt(month) - 1, parseInt(day))
}

const setDateRange = () => {
  dashBoardStore.updateDate(range.value.start, range.value.end)
  calendarModal.value = false
  if (range.value.end && !range.value.start) {
    dashBoardStore.updateDate(range.value.end, range.value.end)
  } else if (!range.value.end && range.value.start) {
    dashBoardStore.updateDate(range.value.start, range.value.start)
  }
  displayStartDate.value = formatTimestampToDate(dashBoardStore.startDate)
  displayEndDate.value = formatTimestampToDate(dashBoardStore.endDate)

  dateFormat.value =
    dateFormat.value === 'Custom range' ? `${displayStartDate.value}  to ${displayEndDate.value}` : dateFormat.value
  // dateFormat.value = dashBoardStore.startDate + ' '+ dashBoardStore.endDate
}

// const displayDateText = () => {
//   if (range.value.start && !range.value.end) {
//     return displayStartDate.value
//   } else if (!range.value.start && range.value.end) {
//     return displayEndDate.value
//   } else {
//     return `${displayStartDate.value}  to ${displayEndDate.value}`
//   }
// }

const validationRules = [
  (val) => {
    if (!val) {
      return true
    }
    const now = new Date()
    const past90Days = new Date(now)
    past90Days.setDate(now.getDate() - 90)

    if (val.start < past90Days) {
      return 'Date should not be before 90 days from today'
    }

    if (val.end > now) {
      return 'Date cannot be greater than the present date'
    }

    return true
  },
]

const allowedDays = (date) => {
  const now = new Date()
  const past90Days = new Date(now)
  past90Days.setDate(now.getDate() - 90)

  return date >= past90Days && date <= now
}

const allowedYears = (year) => {
  const now = new Date()
  const past90Days = new Date(now)
  past90Days.setDate(now.getDate() - 90)

  return year >= past90Days.getFullYear() && year <= now.getFullYear()
}

const allowedMonths = (date) => {
  const now = new Date()
  const past90Days = new Date(now)
  past90Days.setDate(now.getDate() - 90)

  const isCurrentYear = date.getFullYear() === now.getFullYear()
  const isPast90DaysYear = date.getFullYear() === past90Days.getFullYear()

  if (isCurrentYear && isPast90DaysYear) {
    return date.getMonth() >= past90Days.getMonth() && date.getMonth() <= now.getMonth()
  } else if (isCurrentYear) {
    return date.getMonth() <= now.getMonth()
  } else if (isPast90DaysYear) {
    return date.getMonth() >= past90Days.getMonth()
  }

  return false
}

const getTimestamp = (days) => {
  const now = new Date()
  const pastDate = new Date(now)
  pastDate.setDate(now.getDate() - days)
  return { start: pastDate.getTime(), end: now.getTime() }
}

const handelDates = () => {
  if (dateFormat.value === 'Custom range') {
    calendarModal.value = true
  } else {
    switch (dateFormat.value) {
      case 'Last 7 days':
        range.value = getTimestamp(7)
        break
      case 'Last 10 days':
        range.value = getTimestamp(10)
        break
      case 'Last 15 days':
        range.value = getTimestamp(15)
        break
      case 'Last 30 days':
        range.value = getTimestamp(30)
        break
      case 'Last 90 days':
        range.value = getTimestamp(90)
        break
    }
    setDateRange()
  }
}

function formatTimestampToDate(timestamp) {
  const date = new Date(timestamp)

  const year = date.getUTCFullYear()
  const month = String(date.getUTCMonth() + 1).padStart(2, '0') // Months are zero-based
  const day = String(date.getUTCDate() + 1).padStart(2, '0')

  return `${year}-${month}-${day}`
}

const fetchAlertData = async () => {
  const data = await postDataAuth(`user/list-alert`, { email: authStore.email })
  if (data != null) {
    const alertDataList = sortByDate(data)
    // localStorage.setItem('alertDataObj', JSON.stringify(alertDataList))
    alertStore.updateAlertDataObj(alertDataList)
    console.log(alertDataList)
  }
}

function addDomains(data) {
  const domains = []
  data.forEach((obj) => {
    if (obj['domain']) {
      domains.push(obj['domain'])
    }
  })
  return domains
}

watch(
  () => dateFormat.value,
  () => {
    handelDates()
  },
)

onMounted(() => {
  // handelDates()
  if (alertStore.alertDataObj) {
    fetchAlertData()
  }
})
</script>

<style scoped>
.page-title {
  font-size: 24px;
}
.override > .va-input-wrapper {
  display: none !important;
}
</style>
